// Difficulty tiers (per the brief). Each tier scales several dials — not just
// HP — so higher tiers feel different, not just spongier. Multipliers are
// applied in the spawner (enemy HP / spawn rate), AI (contact damage) and the
// boss spawn (boss HP).
export interface Difficulty {
  id: string;
  name: string;
  desc: string;
  enemyHp: number;
  enemyDamage: number;
  enemyRate: number;
  bossHp: number;
}

export const DIFFICULTIES: Difficulty[] = [
  {
    id: "recovery",
    name: "RECOVERY",
    desc: "Assist mode — learn the ropes.",
    enemyHp: 0.7,
    enemyDamage: 0.6,
    enemyRate: 0.75,
    bossHp: 0.7,
  },
  {
    id: "maintenance",
    name: "MAINTENANCE",
    desc: "The standard fight.",
    enemyHp: 1,
    enemyDamage: 1,
    enemyRate: 1,
    bossHp: 1,
  },
  {
    id: "critical",
    name: "CRITICAL",
    desc: "Tougher, faster corruption.",
    enemyHp: 1.3,
    enemyDamage: 1.15,
    enemyRate: 1.25,
    bossHp: 1.3,
  },
  {
    id: "emergency",
    name: "EMERGENCY",
    desc: "The network is failing.",
    enemyHp: 1.6,
    enemyDamage: 1.3,
    enemyRate: 1.5,
    bossHp: 1.6,
  },
  {
    id: "blackout",
    name: "BLACKOUT",
    desc: "Overwhelming. For veterans.",
    enemyHp: 2.0,
    enemyDamage: 1.5,
    enemyRate: 1.8,
    bossHp: 2.0,
  },
  {
    id: "true_glitched",
    name: "TRUE GLITCHED",
    desc: "No mercy. Adapt or collapse.",
    enemyHp: 2.6,
    enemyDamage: 1.8,
    enemyRate: 2.2,
    bossHp: 2.6,
  },
];

export const DEFAULT_DIFFICULTY = 1; // MAINTENANCE

export function difficultyAt(index: number): Difficulty {
  const i = Math.max(0, Math.min(DIFFICULTIES.length - 1, index | 0));
  return DIFFICULTIES[i];
}
